import { AxiosError } from "axios";

const API_ERRORS = new Map<string, string>();
API_ERRORS.set("1", "message.invalidOrganization");
API_ERRORS.set("10", "message.authenticationFailed");
API_ERRORS.set("20", "message.invalidEmailSSO");
API_ERRORS.set("30", "message.notInvited");
API_ERRORS.set("90", "message.authenticationError");

/**
 * get error message key from the error code
 * @param code
 * @returns
 */
export function extractAPIAuthError(code: string | null): string | undefined {
  if (code === "" || code === null) {
    return undefined;
  }
  return API_ERRORS.get(code) ?? "message.error";
}

/**
 * parse message string from unknown TAS error object
 * @param error
 * @returns
 */
export function parseAPIErrorMessage(error: unknown) {
  if (error === undefined || error === null) {
    return "";
  }

  if (typeof error === "string") {
    return error;
  }

  if (error instanceof AxiosError) {
    return (
      error.response?.data.message ??
      error.response?.data.messages?.join(" ") ??
      error.message
    );
  }

  return JSON.stringify(error);
}
